module.exports = __webpack_public_path__ + "img/shopping.36b0ea40.png";